import * as React from "react";
import * as Ui from "semantic-ui-react";
import { Link } from "react-router-dom";

interface Props {}

export const TopMenu: React.FC<Props> = (p) => {
  return (
    <Ui.Menu fixed="top" inverted>
      <Ui.Menu.Item header>
        <Link to="/">Fotokite Package Manager Admin UI</Link>
      </Ui.Menu.Item>
      <Ui.Menu.Item>
        <Link to="/channels">Channels</Link>
      </Ui.Menu.Item>
      <Ui.Menu.Item>
        <Link to="/release/production/latest/beta/latest">
          Release Diff Viewer
        </Link>
      </Ui.Menu.Item>
    </Ui.Menu>
  );
};
